import { render } from "./GoodTablePrices.vue?vue&type=template&id=05b78e85"
import script from "./GoodTablePrices.vue?vue&type=script&lang=js"
export * from "./GoodTablePrices.vue?vue&type=script&lang=js"

import "./GoodTablePrices.vue?vue&type=style&index=0&id=05b78e85&lang=css"

import exportComponent from "/Users/fahrezibayuprabowo/Documents/project/accessories-cellular-frontend-dev-muped/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__